var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclaim = function SvgExclaim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 33.9 30.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 28.1H4.4c-1.5 0-2.4-1.6-1.7-2.9L15.3 3.4c.8-1.3 2.6-1.3 3.4 0l12.6 21.8c.7 1.3-.3 2.9-1.8 2.9m3.8-4.1L20.7 2.2C19.9.8 18.5 0 16.9 0s-3 .8-3.8 2.2L.6 24c-.8 1.4-.8 3 0 4.4s2.2 2.2 3.8 2.2h25.2c1.6 0 3-.8 3.8-2.2.7-1.4.7-3.1-.1-4.4",
    className: "fill-purple"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 23.8c0-1 .8-1.9 1.8-1.9s1.8.8 1.8 1.8-.8 1.8-1.8 1.8c-1 .1-1.8-.7-1.8-1.7m.7-4L15 12c-.1-1.2.8-2.2 2-2.2s2.1 1 2 2.2l-.8 7.9c-.1.6-.6 1-1.2 1-.7 0-1.2-.5-1.2-1.1",
    className: "fill-purple"
  })));
};
export default SvgExclaim;